export default __webpack_public_path__ + "static/media/step4-5.7fed1c06.jpg";